import { bootstrapApplication } from '@angular/platform-browser';
import { applyCachedBrand } from '@crewdle/white-label';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Re-apply the last-known partner brand from localStorage before Angular
// renders anything, so branded users don't see a flash of Crewdle defaults.
// The live Firestore read then confirms or replaces it.
applyCachedBrand();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
